import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state'; import { Action, State, Selector, StateContext } from '@ngxs/store';
// import { utils } from 'src/app/modules/Libs/utils';
// import { BulletinBoardService } from 'src/app/Services/BulletinBoard/bulletin-board-service.service';
// import { BulletinBoardItem } from 'src/app/_interface/BulletinBoardItem';
import { BulletinBoardRefresh, BulletinBoardCreate, BulletinBoardUpdate, BulletinBoardDelete } from './bulletin-board.action';
import { utils } from 'src/app/modules/libs/utils';
import { BulletinBoardItem } from '../bulletin-board-item';
import { BulletinBoardService } from '../bulletin-board-service.service';
import { readStatusSnapshot, writeStatusSnapshot } from '../../status-snapshot-cache';

const BULLETIN_BOARD_SNAPSHOT_KEY = 'home:bulletin-board:snapshot';

export class BulletinBoardStateModel {
  bulletinBoardItems!: BulletinBoardItem[];
  loading!: boolean;
}

@State<BulletinBoardStateModel>({
  name: 'BulletinBoard',
  defaults: {
    bulletinBoardItems: [],
    loading: false
  }
})
@Injectable()
export class BulletinBoardState extends BaseState {
  constructor(
    protected override injector: Injector,
    private bulletinBoardService: BulletinBoardService

  ) {
    super(injector);
  }

  @Selector()
  static read(state: BulletinBoardStateModel) {
    return state.bulletinBoardItems;
  }

  @Action(BulletinBoardRefresh)
  refresh({ getState, patchState }: StateContext<BulletinBoardStateModel>) {
    patchState({ loading: true });

    if (!getState().bulletinBoardItems?.length) {
      const snapshot = readStatusSnapshot<BulletinBoardItem[]>(BULLETIN_BOARD_SNAPSHOT_KEY);
      if (snapshot?.length) patchState({ bulletinBoardItems: snapshot });
    }

    this.bulletinBoardService.getAll().toPromise().then(data => {
      const bulletinBoardItems = utils.cloneDeep(data);
      patchState({ bulletinBoardItems, loading: false });
      writeStatusSnapshot(BULLETIN_BOARD_SNAPSHOT_KEY, bulletinBoardItems);
    }).catch(error => {
      patchState({ loading: false });
      console.error(error);
    });
  }

  @Action(BulletinBoardCreate)
  create({ getState, patchState }: StateContext<BulletinBoardStateModel>, { item }: BulletinBoardCreate) {
    const bulletinBoardItems = [...getState().bulletinBoardItems, item];
    patchState({ bulletinBoardItems });
    writeStatusSnapshot(BULLETIN_BOARD_SNAPSHOT_KEY, bulletinBoardItems);
  }

  @Action(BulletinBoardUpdate)
  update({ getState, patchState }: StateContext<BulletinBoardStateModel>, { id, item }: BulletinBoardUpdate) {
    const state = getState();
    const index = state.bulletinBoardItems.findIndex(x => x.id === id);
    const currentState = utils.cloneDeep(state.bulletinBoardItems);

    if (index >= 0) {
      currentState.splice(index, 1, utils.cloneDeep(item));
      patchState({ bulletinBoardItems: currentState });
      writeStatusSnapshot(BULLETIN_BOARD_SNAPSHOT_KEY, currentState);
    }
  }

  @Action(BulletinBoardDelete)
  delete({ getState, patchState }: StateContext<BulletinBoardStateModel>, { id }: BulletinBoardDelete) {
    const bulletinBoardItems = getState().bulletinBoardItems.filter(x => x.id !== id);
    patchState({ bulletinBoardItems });
    writeStatusSnapshot(BULLETIN_BOARD_SNAPSHOT_KEY, bulletinBoardItems);
  }
}
